import { DRAWERS_PANEL_WIDTH } from './DrawersPanel/DrawersPanel.constants.js';
import DrawersPanel from './DrawersPanel/DrawersPanel.jsx';
import Header from './Header/Header.jsx';
import LevelDetails from './LevelDetails/LevelDetails.jsx';

const PlanningContent = () => {
  return (
    <div
      className="flex h-full flex-row"
      style={{ paddingRight: `${DRAWERS_PANEL_WIDTH}px` }}
    >
      <div className="flex flex-1 flex-col">
        <Header />
        <LevelDetails />
      </div>
      <DrawersPanel />
    </div>
  );
};

export default PlanningContent;
